import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';
 
export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: ENDPOINTS.AUTH.LOGIN,
        method: 'POST',
        body: { ...credentials },
      }),
    }),
    reLogin: builder.mutation({
      query: (credentials) => ({
        url: ENDPOINTS.AUTH.RELOGIN,
        method: 'POST',
        body: { ...credentials },
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: ENDPOINTS.AUTH.LOGOUT,
        method: 'POST',
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(apiSlice.util.resetApiState());
        } catch (error) {
          console.error('Logout failed:', error);
        }
      },
    }),
    refreshToken: builder.query({
      query: () => `${ENDPOINTS.AUTH.REFRESH_TOKEN}`,
    }),
    passwordConfirm: builder.mutation({
      query: (data) => ({
        url: ENDPOINTS.AUTH.PASSWORD_CONFIRM,
        method: 'POST',
        body: data,
      }),
    }),
    sendForgotPasswordEmail: builder.mutation({
      query: (data) => ({
        url: ENDPOINTS.AUTH.FORGOT_PASSWORD_MAIL,
        method: 'POST',
        body: data,
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ token, password, confirmPassword }) => ({
        url: `${ENDPOINTS.AUTH.RESET_PASSWORD}${token}`,
        method: 'POST',
        body: { password, confirmPassword },
      }),
    }),
    addFcmToken: builder.mutation({
      query: (data) => ({
        url:`${ENDPOINTS.FCMTOKEN.ADDFCMTOKEN}`,
        method: 'POST',
        body: data
      })
    }),
    removeFcmToken: builder.mutation({
      query: (data) => ({
        url:`${ENDPOINTS.FCMTOKEN.REMOVEFCMTOKEN}`,
        method: 'POST',
        body: data
      })
    }),
    addVersion:builder.mutation({
      query: (data) => ({
        url:`${ENDPOINTS.VERSION.ADDVERSION}`,
        method: 'POST',
        body: data
      })
    }),
    getVersion:builder.query({
      query: (deviceType) => ({
        url:`${ENDPOINTS.VERSION.GETVERSION}/${deviceType}`,
        method: 'GET',
      }),
    }),
    getEmployeeProfile:builder.query({
      query: (empCode) => ({
        url: `${ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_PROFILE}/${empCode}`,
        method: 'GET',
      }),
    })
  }),
});
 
export const {
  useLoginMutation,
  useReLoginMutation,
  useLogoutMutation,
  useRefreshTokenQuery,
  usePasswordConfirmMutation,
  useSendForgotPasswordEmailMutation,
  useResetPasswordMutation,
  useAddFcmTokenMutation,
  useRemoveFcmTokenMutation,
  useAddVersionMutation,
  useGetVersionQuery,
  useGetEmployeeProfileQuery
} = authApiSlice;